// Redux/reducers/receptionistReducers/receptionistReducer.js
import {
  LOOKUP_PATIENT_REQUEST,
  LOOKUP_PATIENT_SUCCESS,
  LOOKUP_PATIENT_FAIL,
  LOOKUP_PATIENT_RESET,
  CREATE_WALKIN_REQUEST,
  CREATE_WALKIN_SUCCESS,
  CREATE_WALKIN_FAIL,
  FETCH_DEPARTMENTS_REQUEST,
  FETCH_DEPARTMENTS_SUCCESS,
  FETCH_DEPARTMENTS_FAIL,
  FETCH_DOCTORS_BY_DEPT_REQUEST,
  FETCH_DOCTORS_BY_DEPT_SUCCESS,
  FETCH_DOCTORS_BY_DEPT_FAIL,
  FETCH_APPOINTMENTS_REQUEST,
  FETCH_APPOINTMENTS_SUCCESS,
  FETCH_APPOINTMENTS_FAIL,
  ASSIGN_APPOINTMENT_REQUEST,
  ASSIGN_APPOINTMENT_SUCCESS,
  ASSIGN_APPOINTMENT_FAIL,
  REJECT_APPOINTMENT_REQUEST,
  REJECT_APPOINTMENT_SUCCESS,
  REJECT_APPOINTMENT_FAIL,
  COMPLETE_APPOINTMENT_REQUEST,
  COMPLETE_APPOINTMENT_SUCCESS,
  COMPLETE_APPOINTMENT_FAIL,
  PRINT_PAYMENT_RECEIPT_REQUEST,
  PRINT_PAYMENT_RECEIPT_SUCCESS,
  PRINT_PAYMENT_RECEIPT_FAIL,
  MEDICINES_SEARCH_REQUEST,
  MEDICINES_SEARCH_SUCCESS,
  MEDICINES_SEARCH_FAIL,
  SEARCH_PATIENTS_REQUEST,
  SEARCH_PATIENTS_SUCCESS,
  SEARCH_PATIENTS_FAIL,
} from "../../constants/receptionistConstants/receptionistConstants";

const initialState = {
  loading: false,
  error: null,
  patient: null,
  appointments: [],
  departments: [],
  doctors: [],
  currentAppointment: null,
};

export const receptionistReducer = (state = initialState, action) => {
  switch (action.type) {
    // Lookup patient
    case LOOKUP_PATIENT_REQUEST:
      return { ...state, loading: true, error: null };
    case LOOKUP_PATIENT_SUCCESS:
      return { ...state, loading: false, patient: action.payload };
    case LOOKUP_PATIENT_FAIL:
      return { ...state, loading: false, error: action.payload, patient: null };
    case LOOKUP_PATIENT_RESET:
      return { ...state, patient: null, error: null };
    case SEARCH_PATIENTS_REQUEST:
    return { ...state, loading: true };
    case SEARCH_PATIENTS_SUCCESS:
    return { ...state, loading: false, searchResults: action.payload };
    case SEARCH_PATIENTS_FAIL:
    return { ...state, loading: false, error: action.payload };
    // Create walk-in
    case CREATE_WALKIN_REQUEST:
      return { ...state, loading: true, error: null };
    case CREATE_WALKIN_SUCCESS:
      return {
        ...state,
        loading: false,
        currentAppointment: action.payload,
        appointments: [action.payload, ...state.appointments],
      };
    case CREATE_WALKIN_FAIL:
      return { ...state, loading: false, error: action.payload };

    // Departments
    case FETCH_DEPARTMENTS_REQUEST:
      return { ...state, loading: true, error: null };
    case FETCH_DEPARTMENTS_SUCCESS:
      return { ...state, loading: false, departments: action.payload };
    case FETCH_DEPARTMENTS_FAIL:
      return { ...state, loading: false, error: action.payload };

    // Doctors by department
    case FETCH_DOCTORS_BY_DEPT_REQUEST:
      return { ...state, loading: true, error: null };
    case FETCH_DOCTORS_BY_DEPT_SUCCESS:
      return { ...state, loading: false, doctors: action.payload };
    case FETCH_DOCTORS_BY_DEPT_FAIL:
      return { ...state, loading: false, error: action.payload };

    // Appointments
    case FETCH_APPOINTMENTS_REQUEST:
      return { ...state, loading: true, error: null };
    case FETCH_APPOINTMENTS_SUCCESS:
      return { ...state, loading: false, appointments: action.payload };
    case FETCH_APPOINTMENTS_FAIL:
      return { ...state, loading: false, error: action.payload };

    // Assign
    case ASSIGN_APPOINTMENT_REQUEST:
      return { ...state, loading: true, error: null };
    case ASSIGN_APPOINTMENT_SUCCESS:
      return {
        ...state,
        loading: false,
        appointments: state.appointments.map((appt) =>
          appt._id === action.payload._id ? action.payload : appt
        ),
      };
    case ASSIGN_APPOINTMENT_FAIL:
      return { ...state, loading: false, error: action.payload };

    // Reject
    case REJECT_APPOINTMENT_REQUEST:
      return { ...state, loading: true, error: null };
    case REJECT_APPOINTMENT_SUCCESS:
      return {
        ...state,
        loading: false,
        appointments: state.appointments.map((appt) =>
          appt._id === action.payload._id ? action.payload : appt
        ),
      };
    case REJECT_APPOINTMENT_FAIL:
      return { ...state, loading: false, error: action.payload };

    // Complete
    case COMPLETE_APPOINTMENT_REQUEST:
      return { ...state, loading: true, error: null };
    case COMPLETE_APPOINTMENT_SUCCESS:
      return {
        ...state,
        loading: false,
        appointments: state.appointments.map((appt) =>
          appt._id === action.payload._id ? action.payload : appt
        ),
      };
    case COMPLETE_APPOINTMENT_FAIL:
      return { ...state, loading: false, error: action.payload };

    // Print payment
    case PRINT_PAYMENT_RECEIPT_REQUEST:
      return { ...state, loading: true, error: null };
    case PRINT_PAYMENT_RECEIPT_SUCCESS:
      return {
        ...state,
        loading: false,
        appointments: state.appointments.map((appt) =>
          appt._id === action.payload._id ? action.payload : appt
        ),
      };
    case PRINT_PAYMENT_RECEIPT_FAIL:
      return { ...state, loading: false, error: action.payload };

      // Medince Search
      // Medicines Search
    case MEDICINES_SEARCH_REQUEST:
      return {
        ...state,
        medicinesSearchLoading: true,
        medicinesSearchError: null,
      };
    case MEDICINES_SEARCH_SUCCESS:
      return {
        ...state,
        medicinesSearchLoading: false,
        medicinesSearch: action.payload,
        medicinesSearchError: null,
      };
    case MEDICINES_SEARCH_FAIL:
      return {
        ...state,
        medicinesSearchLoading: false,
        medicinesSearchError: action.payload,
        medicinesSearch: [],
      };
    default:
      return state;
  }
};